export const getAllServiceCategoriesQuery = `
query GetAllServiceCategories {
    getAllServiceCategories {
        id
        title
        icon
        description
    }
}
`;

export const AddServiceCategoryQuery = `
mutation AddServiceCategory($input: CreateServiceCategoryInput!) {
    addServiceCategory(input: $input) {
        id
        title
        description
    }
}
`;

export const UpdateServiceCategoryQuery = `
mutation UpdateServiceCategory($input: UpdateServiceCategoryInput!) {
    updateServiceCategory(input: $input) {
        id
        title
        description
    }
}
`;

export const DeleteServiceCategoryQuery = `
mutation DeleteServiceCategory($id: ID!) {
    deleteServiceCategory(id: $id) {
        status
    }
}
`;
